import { formatMoneyCents } from '../../../utils/money';
import { expectedCostQualifier, type ExpectedCostSummary } from './poCost';

interface ExpectedCostProps {
    summary: ExpectedCostSummary;
    /** Larger, left-aligned rendering for the drawer's cost panel. */
    emphasis?: boolean;
}

// Never renders a bare total when some lines have no vendor cost - the
// qualifier rides along so a partial sum can't be read as the real one.
export function ExpectedCost({ summary, emphasis = false }: ExpectedCostProps) {
    const qualifier = expectedCostQualifier(summary);

    if (summary.totalCents === null) {
        return (
            <span className={emphasis ? 'text-sm text-gray-400' : 'text-sm text-gray-300'}>
                No vendor cost
            </span>
        );
    }

    return (
        <span className={`flex flex-col ${emphasis ? 'items-start' : 'items-end'}`}>
            <span
                className={
                    emphasis
                        ? 'text-lg font-bold text-gray-900 tabular-nums'
                        : 'text-sm font-semibold text-gray-900 tabular-nums'
                }
            >
                {formatMoneyCents(summary.totalCents)}
                {!summary.complete && <span className="text-amber-600">+</span>}
            </span>
            {qualifier && <span className="text-[11px] text-amber-600">{qualifier}</span>}
        </span>
    );
}
